import React from 'react';
import { useTranslation } from 'react-i18next';
import enTexts from './LebenslaufEn.json';
import deTexts from './LebenslaufDe.json';
import styles from './Lebenslauf.module.css';

const Lebenslauf = () => {
    const { i18n } = useTranslation();
    const texts = i18n.language.startsWith('de') ? deTexts : enTexts;

    // Formatierung des aktuellen Datums (z.B. TT.MM.JJJJ)
    const currentDate = new Date().toLocaleDateString(i18n.language.startsWith('de') ? 'de-DE' : 'en-US');

    // Falls in den Übersetzungsdateien kein Array vorhanden ist, werden Fallback-Daten genutzt:
    const timelineData = texts.timelineEvents || [
        {
            year: currentDate,
            title: "Aktuelles Event",
            description: "There is a buggy in the system, that's a new sensation!"
        }
    ];


    return (
        <div className={styles.timelineContainer}>
            <div className={styles.currentDate}>
                <span className={styles.dateText}>{currentDate}</span>
                <span className={styles.arrow}>▲</span>
            </div>
            <div className={styles.timelineLine}></div>
            {timelineData.map((event, index) => (
                <div
                    key={index}
                    className={`${styles.event} ${index % 2 === 0 ? styles.left : styles.right}`}
                    id={`event-${index}`}
                >
                    <div className={styles.content}>
                        <h3>{event.title}</h3>
                        <span className={styles.year}>{event.year}</span>
                        <p>{event.description}</p>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Lebenslauf;
